import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-straightLine",
  "use": "icon-straightLine-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-straightLine\"><path d=\"M197.333 766.293L766.08 197.632l60.33 60.33L257.665 826.71z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol